export default {
  hide: 'Hide',
  end: 'End',
};
